import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { BaseFormComponent } from './../../../../shared/components/base-form/base-form.component';

@Component({
  selector: 'app-osa-execucao-aba-custos-recursos',
  templateUrl: './osa-execucao-aba-custos-recursos.component.html',
  styleUrls: ['./osa-execucao-aba-custos-recursos.component.scss']
})
export class OsaExecucaoAbaCustosRecursosComponent extends BaseFormComponent implements OnInit {

  @Input() visualizar: boolean;
  @Input() hiddenEdicao: boolean;

  totalEquipePlanejado = 0;
  totalOutrosPlanejado = 0;
  totalEquipeExecucao = 0;
  totalOutrosExecucao = 0;

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    public matDialog: MatDialog,
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnInit(): void {
  }
}
